import React, { Component } from "react";
import { translate } from 'react-i18next';
import { TextField } from "@mui/material";
import { url } from "../../config";
import { getFormatedDate } from "../../helpers/fotmatDate";

class List extends Component {
    state = {
        feedbackMessage: null,
        id: ''
    }

    getSuggestionById = (e) => {
        if (e?.preventDefault) e.preventDefault();
        if (this.state.id) {
            this.props.updateAppState('isLoadingTransparentBackground', true);
            fetch(url(`suggestion/suggestions/getSuggestionById/${this.state.id}?lang=${localStorage.getItem('i18nextLng').toUpperCase()}`, null, "GET"))
                .then(res => res.text())
                .then((getSuggestionByIdResponseJSON) => {
                    const JSON = require('true-json-bigint');
                    let getSuggestionByIdResponse = JSON.parse(getSuggestionByIdResponseJSON);
                    if (getSuggestionByIdResponse.status.statusCode !== 1) {
                        if (getSuggestionByIdResponse.status.statusCode === 200) {
                            this.props.logout();
                        } else {
                            this.props.alertState(true, 'error', this.props.t('an error occurred'), getSuggestionByIdResponse.status.statusMessage);
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                        }
                    }
                    else {
                        this.props.history.push(`/feedback/list/${this.state.id}`)
                        this.setState({ model: getSuggestionByIdResponse.model })
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                },
                    (error) => {
                        this.props.history.push("/technical-break");
                    });
        }
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            this.setState({ id: this.props.match.params.id }, () => this.getSuggestionById())
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (!this.props.match.params.id) {
                this.setState({ model: null, id: null })
            }
        }
    }

    render() {
        let { model } = this.state;
        let { t } = this.props;
        return (
            model ?
                <div className="feedback-list-item col-12 col-md-9 col-lg-7 col-xl-5">
                    <h3 className="w-100 mb-3">{t('Request result')}</h3>
                    <div className="d-flex flex-column col-12 col-sm-6">
                        <p>{t('Reference number')}</p>
                        <h6>{model?.registerNumber || "--"}</h6>

                        <p>{t('Submission date')}</p>
                        <h6>{model?.dateOfShipment || "--"}</h6>

                        <p>{t('Status')}</p>
                        <h6>{model?.status || "--"}</h6>

                        <p>{t('Response date')}</p>
                        <h6>{model?.responseDate || "--"}</h6>
                    </div>
                    <div className="d-flex flex-column col-12 col-sm-6">
                        <p>{t('First name, Last name, Patronymic')}</p>
                        <h6>{model?.fullName || "--"}</h6>

                        <p>{t('Result')}</p>
                        <h6>{model?.responseText || "--"}</h6>
                    </div>
                </div> :
                <form onSubmit={this.getSuggestionById}>
                    <h3 className="mx-auto mb-4">{t('Track the request')}</h3>
                    <TextField sx={{ width: "100%" }} label={t('Reference number')} variant="outlined" onChange={(e) => this.setState({ id: e.target.value })} />
                    <button type="submit">{t('Search')}</button>
                </form>
        )
    }
}

export default translate("translation")(List);